/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/CancelAction/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let selectedValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
format: fromHelpers.getActionName,
})
let selectedValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
})
let manualActionExecutionsValueData = fromData.useDataValue({ viewPath,
context: 'manual_action_executions',
})
let aggregateData = fromHelpers.isLast(selectedValueData1, manualActionExecutionsValueData)
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 onClick={onClick}
 marginLeft={dtSpaceXs}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={selectedValueData ? "Go back and complete" : aggregateData ? "Submit" : "Cancel"}
 data={selectedValueData ? "selected" : "selected"}
 format="helpers.js getActionName"
/>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}